import { Modal, Tab } from '@mairistem/composants';
import { getMenuItem } from '@mairistem/finances-utils';
import React from 'react';
import type Simulation from '../../../../interfaces/simulation/simulation';
import {
	hasLignesRapport,
	parseResultatRapport,
	type ResultatRapport,
} from '../../../../utils/simulation/rapportImputationsNonTrouvees';
import RapportImputationsNonTrouvees from '../RapportImputationsNonTrouvees';
import ImportApcp from './ImportApcp';
import ImportBien from './ImportBien';
import ImportEmprunt from './ImportEmprunt';
import ImportInformations from './importInformations';
import './ImportModal.css';

interface ImportModalProps {
	open: boolean;
	onClose: () => void;
	onValidate: () => void;
	simulation: Simulation;
	hasCa: boolean;
}

const ImportModal = ({
	open,
	onValidate,
	onClose,
	simulation,
	hasCa,
}: ImportModalProps) => {
	// Renseigne si l'import APCP termine avec succes a ignore des lignes, faute
	// d'imputation equivalente ou d'espace du service contenant l'imputation
	const [rapport, setRapport] = React.useState<ResultatRapport>();

	const handleClose = () => onClose?.();

	const handleValidateApcp = (resultat?: string) => {
		const resultatRapport = parseResultatRapport(resultat);
		if (hasLignesRapport(resultatRapport)) {
			setRapport(resultatRapport);
		} else {
			onValidate();
		}
	};

	const handleCloseRapport = () => {
		setRapport(undefined);
		// Les autres lignes ont ete importees : on rafraichit la simulation
		onValidate();
	};

	const titre = hasCa
		? 'Alimenter les restes à réaliser à partir des logiciels métiers'
		: 'Alimenter les propositions à partir des logiciels métiers';

	const PANES = [
		{
			menuItem: (_, props) =>
				getMenuItem({
					...props,
					content: 'Informations',
					'data-testid': 'informationsMenu',
				}),
			render: () => (
				<Tab.Pane>
					<ImportInformations />
				</Tab.Pane>
			),
		},
		...(!hasCa
			? [
					{
						menuItem: (_, props) =>
							getMenuItem({
								...props,
								content: 'Gestion des emprunts',
								'data-testid': 'empruntMenu',
							}),
						render: () => (
							<Tab.Pane>
								<ImportEmprunt
									simulation={simulation}
									onClose={handleClose}
									onValidate={onValidate}
								/>
							</Tab.Pane>
						),
					},
					{
						menuItem: (_, props) =>
							getMenuItem({
								...props,
								content: 'Gestion des biens',
								'data-testid': 'bienMenu',
							}),
						render: () => (
							<Tab.Pane>
								<ImportBien
									simulation={simulation}
									onClose={handleClose}
									onValidate={onValidate}
								/>
							</Tab.Pane>
						),
					},
				]
			: []),

		{
			menuItem: (_, props) =>
				getMenuItem({
					...props,
					content: 'APCP',
					'data-testid': 'apcpMenu',
				}),
			render: () => (
				<Tab.Pane>
					<ImportApcp
						simulation={simulation}
						onClose={handleClose}
						onValidate={handleValidateApcp}
						hasCa={hasCa}
					/>
				</Tab.Pane>
			),
		},
	];

	return (
		<Modal
			closeIcon
			onClose={rapport ? handleCloseRapport : handleClose}
			size="fullscreen"
			open={open}
		>
			<Modal.Header content={titre} />
			{rapport ? (
				<RapportImputationsNonTrouvees
					anneeExercice={simulation.exercice.anneeExercice}
					imputations={rapport.imputationsNonTrouvees}
					imputationsHorsEspace={rapport.imputationsHorsEspace}
					onClose={handleCloseRapport}
					traitement="Import effectué."
				/>
			) : (
				<Modal.Content>
					<Tab
						grid={{ tabWidth: 2, paneWidth: 14 }}
						menu={{
							pointing: true,
							secondary: true,
							vertical: true,
						}}
						panes={PANES}
					/>
				</Modal.Content>
			)}
		</Modal>
	);
};

export default ImportModal;
